module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("HELLO, WELL-INTENTIONED PERSON OF PALLOR!")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("It’s Daquan—the black coworker you are referring to when you claim to have black friends.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("You are reading this book because you want to know what not to say. They get mad at you when you say the wrong thing. But no one will tell you, up front, what not to say. Well, I will tell you. Because I am your friend. Your real black friend.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f1ecc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/intro1.vue
// module id = 66
// module chunks = 0